import i18next from "i18next";

const I18N_NS_DEVELOPMENT = ["development"] as const;

/**
 * Handles backend messages by checking if the message is a Locize key.
 * If it is, it returns the translated text. Otherwise, it returns
 * the original message as it is.
 *
 * @param message - The backend message or i18n key
 * @returns Translated message if key exists, otherwise the original message
 */
export const handleBackendMessage = (message: string): string => {
  if (!message) return "";
  const isI18nKey = i18next.exists(message, {
    ns: I18N_NS_DEVELOPMENT,
  });
  return isI18nKey ? i18next.t(message) : message;
};

